import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link, Outlet } from "react-router-dom";
import { setState as setStateCreate } from "./Scenario/scenarioSetupNewSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Setup() {
  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0);
  const pathname = useLocation().pathname.replace("/SiMS_ReactJS", "");

  dispatch(setStateCreate("editMode", true));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={pathname}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="Scenario Setup"
            {...a11yProps(0)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="/setup/scenario"
            value={"/setup/scenario"}
          />
          <Tab
            label="Customer Group Setup"
            {...a11yProps(1)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="/setup/customer-group"
            value={"/setup/customer-group"}
          />
          <Tab
            label="Product Group Setup"
            {...a11yProps(2)}
            sx={{ textTransform: "none" }}
            component={Link}
            to="/setup/product-group"
            value={"/setup/product-group"}
          />
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
}
